import { ClientItemId } from 'owa-client-ids';
import { isConnectedAccount } from 'owa-accounts-store';
import { AddPopoutSource, addPopoutV2 } from 'owa-popout-v2';
import { CALENDAR_POPOUT_OPTIONS } from './popoutCalendarCompose';

export default function popoutCalendarReadingPane(
    calendarItemId: ClientItemId,
    actionSource: string,
    data?: Object,
    source?: AddPopoutSource,
    includeFluidOnPopout?: boolean
) {
    const accountRoute = isConnectedAccount(calendarItemId.mailboxInfo.userIdentity)
        ? 'account/' + encodeURIComponent(calendarItemId.mailboxInfo.userIdentity) + '/'
        : '';

    const route = 'read/' + accountRoute + encodeURIComponent(calendarItemId.Id);

    addPopoutV2(
        'calendar',
        route,
        {
            ...data,
            entrySource: actionSource,
            includeFluidOnPopout,
        },
        CALENDAR_POPOUT_OPTIONS,
        false /* skipOptinCheck */,
        actionSource
    );
}
